import { graphql } from "gatsby";
import {
  DailySchedule,
  IContentfulLink,
  LabelsOverrideContentful,
  RichTextType,
  ScheduleList,
  convertLabelsToMap,
} from "@parksandresorts/core";

type DailyScheduleBlockProps = {
  scheduleList: Array<ScheduleList>;
  showConcertsInCalendar: boolean;
  promotionBannerText: RichTextType;
  promotionBannerLink: IContentfulLink;
  labelsOverride: LabelsOverrideContentful;
  concertInformationText: RichTextType;
  concertInformationCta: IContentfulLink;
  dateInformationHeadline: string;
  dateInformationText: RichTextType;
  dateInformationDate: Date;
};

const DailyScheduleBlock = (props: DailyScheduleBlockProps) => {
  const scheduleList = props?.scheduleList;
  const showConcertsInCalendar = props?.showConcertsInCalendar;
  const promotionBannerText = props?.promotionBannerText;
  const promotionBannerLink = props?.promotionBannerLink;
  const concertInformationText = props?.concertInformationText;
  const concertInformationCTA = props?.concertInformationCta;
  const dateInformationHeadline = props?.dateInformationHeadline;
  const dateInformationText = props?.dateInformationText;
  const dateInformationDate = props?.dateInformationDate;

  return (
    <DailySchedule
      scheduleList={scheduleList}
      showConcertsInCalendar={showConcertsInCalendar}
      promotionBannerText={promotionBannerText}
      promotionBannerLink={promotionBannerLink}
      labelsOverride={convertLabelsToMap(props?.labelsOverride)}
      concertInformationText={concertInformationText}
      concertInformationCTA={concertInformationCTA}
      dateInformationHeadline={dateInformationHeadline}
      dateInformationText={dateInformationText}
      dateInformationDate={dateInformationDate}
    />
  );
};

export default DailyScheduleBlock;
export const fragmentDailyScheduleBlock = graphql`
  fragment DailyScheduleBlock on ContentfulDailyScheduleBlock {
    contentful_id
    id
    scheduleList {
      contentful_id
      title
      scheduleType
      listedByTags {
        title
      }
      isExpanded
      groupAdmissionList {
        ...GroupAdmissionBlock
      }
    }
    showConcertsInCalendar
    promotionBannerText {
      raw
    }
    promotionBannerLink {
      ...Link
    }
    labelsOverride {
      list {
        key
        value
      }
    }
    concertInformationText {
      raw
    }
    concertInformationCta {
      ...Link
    }
    dateInformationHeadline
    dateInformationText {
      raw
    }
    dateInformationDate
  }
`;
